import { render, staticRenderFns } from "./workWexin.vue?vue&type=template&id=bbc60b5e&scoped=true"
import script from "./workWexin.vue?vue&type=script&lang=js"
export * from "./workWexin.vue?vue&type=script&lang=js"
import style0 from "./workWexin.vue?vue&type=style&index=0&id=bbc60b5e&prod&less=lang&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbc60b5e",
  null
  
)

export default component.exports